import { render, staticRenderFns } from "./BrandEditView.vue?vue&type=template&id=3dbb504b"
import script from "./BrandEditView.vue?vue&type=script&lang=js"
export * from "./BrandEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports